import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from '../../services/storage.service';
import { Subscription } from 'rxjs';
import { OAuthService, OAuthSuccessEvent } from 'angular-oauth2-oidc';
import { GS1LoadingService } from '@gs1france/gs1-components-library';
import { TokenGS1Service } from '../../services/tokenGS1.service';

@Component({
    selector: 'login',
    template: ''
})
export class LoginComponent implements OnInit, OnDestroy {

    isAuthorizedSubscription: Subscription;
    isAuthorized: boolean;
    tokenAdmin ='';
    constructor(private router: Router, private oauthService:OAuthService, private storageService: StorageService, private loadingService: GS1LoadingService
        ,private _tokenGS1Service: TokenGS1Service,
        ) {

    }

    ngOnInit() {
        this.loadingService.startLoading('login');
        this.getData();
    }

    async getData() {
        this.loadingService.stopLoading('login');
        await this._tokenGS1Service.getTokenGS1('1e479963-5af0-43f7-9cea-10b9e63f59b0');

         const tokenAdmin = localStorage.getItem('tokenGS1Admin');
        if (tokenAdmin) {
           this.tokenAdmin = tokenAdmin;
          localStorage.setItem("tokenAdmin", tokenAdmin);
          this.loadingService.stopLoading('entreprises');
          this.router.navigate(["/accueil"]);
        } else {
           this.router.navigate(["/unauthorized"]);
        }
      }
      

    ngOnDestroy(): void {
        if (this.isAuthorizedSubscription)
            this.isAuthorizedSubscription.unsubscribe();
    }
}
